import React from "react";
import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { CONTACT } from "@/data/site";

const GoogleG = (props) => (
  <svg viewBox="0 0 48 48" {...props}><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
);

export default function GoogleReviews({ compact = false }) {
  return (
    <section className={compact ? "" : "py-16 md:py-20"} data-testid="google-reviews-section">
      <div className={compact ? "" : "max-w-7xl mx-auto px-5 md:px-10"}>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="bg-white rounded-[2rem] border border-slate-100 shadow-[0_20px_60px_-25px_rgba(10,37,64,0.15)] p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <GoogleG className="w-14 h-14" />
            <div>
              <p className="font-heading font-bold text-navy text-xl">Google Reviews</p>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-2xl font-bold text-navy font-heading">5.0</span>
                <div className="flex text-amber-400">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" />)}</div>
              </div>
              <p className="text-sm text-secondary mt-1">Loved by patients across the city</p>
            </div>
          </div>
          <a href={CONTACT.googleReviewsUrl} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white rounded-full px-7 py-3.5 font-medium transition-all hover:-translate-y-0.5" data-testid="google-reviews-btn">
            Read our Google Reviews <ExternalLink className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
